export default __webpack_public_path__ + "static/sliding_door_w.4234bea72016ade5bbeb840c71952b73.png";